import type { TOC } from "@ember/component/template-only";
import { t } from "ember-intl";
import { or } from "ember-truth-helpers";
import GButtonLink from "glesys-controlpanel/components/g-button/link";
import GButtonLinkTo from "glesys-controlpanel/components/g-button/link-to";
import IconsExternalLink from "glesys-controlpanel/components/icons/external-link";
import GButton from "glesys-controlpanel/components/g-button";
import { on } from "@ember/modifier";

export interface EmptyStateActionsSignature {
  Args: {
    learnMoreUrl?: string;
    learnMoreAriaLabel?: string;
    createRoute?: string;
    createLabel?: string;
    createColor?: "green" | "blue";
    onCreate?: () => void;
    contactUrl?: string;
  };
}

const EmptyStateActions: TOC<EmptyStateActionsSignature> = <template>
  {{#if (or @learnMoreUrl @createRoute @onCreate @contactUrl)}}
    <div class="flex items-center gap-4" data-test-empty-state-actions>
      {{#if @learnMoreUrl}}
        <GButtonLink
          aria-label={{@learnMoreAriaLabel}}
          data-test-empty-state-learn-more
          href={{@learnMoreUrl}}
          target="_blank"
          rel="noopener noreferrer"
        >
          {{t "button.learn-more"}}
          <IconsExternalLink class="size-3.5 ml-2" />
        </GButtonLink>
      {{/if}}
      {{#if @createRoute}}
        <GButtonLinkTo data-test-empty-state-create @route={{@createRoute}} @color={{or @createColor "green"}}>
          {{@createLabel}}
        </GButtonLinkTo>
      {{else if @onCreate}}
        <GButton data-test-empty-state-create @color={{or @createColor "green"}} {{on "click" @onCreate}}>
          {{@createLabel}}
        </GButton>
      {{/if}}
      {{#if @contactUrl}}
        <GButtonLink
          aria-label={{t "button.contact-sales-aria-label"}}
          data-test-empty-state-contact
          href={{@contactUrl}}
          target="_blank"
          rel="noopener noreferrer"
          @color="blue"
        >
          {{t "button.contact-sales"}}
          <IconsExternalLink class="size-3.5 ml-2" />
        </GButtonLink>
      {{/if}}
    </div>
  {{/if}}
</template>;

export default EmptyStateActions;
